import { linkStatusPieChartColor } from "../../../reusableComponents/constants";

export const trafficByDevicesSchema = (dataPoints, overAllMetric) => {
  const chartOptions = {
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            let label = context?.label || "";
            if (label) {
              label += ": ";
            }
            if (context?.parsed) {
              label += context.parsed + "%";
            }
            return label;
          },
        },
      },
      legend: {
        padding: 20,
        position: "right",
        labels: {
          usePointStyle: true,
          generateLabels: function (chart) {
            const data = chart?.data;
            if (data?.labels?.length && data?.datasets?.length) {
              return data?.labels.map(function (label, i) {
                const value = data?.datasets[0].data[i];
                return {
                  text: label + ": " + value + "%",
                  fillStyle: data?.datasets[0].backgroundColor[i],
                  hidden:
                    isNaN(data?.datasets[0].data[i]) ||
                    chart.getDatasetMeta(0).data[i].hidden,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      datalabels: {
        formatter: function (value, context) {
          return context.chart.data.labels[context.dataIndex];
        },
      },
    },
  };

  const chartData = {
    labels: dataPoints?.map((item) => item?.deviceType),
    datasets: [
      {
        label: "Payment Category Split by Transaction Count",
        data: dataPoints.map((item) => item?.trafficPercent),
        backgroundColor: linkStatusPieChartColor,
        borderColor: "#fff",
        borderWidth: 1,
        hoverBackgroundColor: linkStatusPieChartColor,
      },
    ],
  };

  return { dataPoints, chartData, chartOptions };
};
